/* ============================================================
   STORIYA — JavaScript principal
   Thème Shopify 2.0 — v1.0
   ============================================================ */

(function() {
  'use strict';

  // ── NAV SCROLL ──
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── MOBILE NAV ──
  const toggleBtn = document.querySelector('.nav-mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const closeBtn  = document.querySelector('.mobile-nav-close');
  if (toggleBtn && mobileNav) {
    toggleBtn.addEventListener('click', () => mobileNav.classList.add('open'));
    closeBtn && closeBtn.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('open')));
  }

  // ── SCROLL REVEAL ──
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => obs.observe(el));
  }

  // ── FAQ ACCORDION ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── CART COUNT ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── ANNOUNCEMENT BAR CLOSE ──
  const annClose = document.querySelector('.announcement-close');
  if (annClose) {
    annClose.addEventListener('click', () => {
      const bar = document.querySelector('.announcement-bar');
      if (bar) { bar.style.height = bar.offsetHeight + 'px'; bar.classList.add('closing'); }
    });
  }

  // ── PHOTO UPLOADER ──
  class StoriyaUploader {
    constructor(container) {
      this.container = container;
      this.photos    = [];
      this.maxPhotos = parseInt(container.dataset.max) || 20;
      this.minPhotos = parseInt(container.dataset.min) || 1;
      this.step      = 1;
      this.init();
    }

    init() {
      this.dropZone   = this.container.querySelector('#drop-zone');
      this.fileInput  = this.container.querySelector('#photo-file-input');
      this.thumbGrid  = this.container.querySelector('#photo-thumb-grid');
      this.countEl    = this.container.querySelector('#photo-count');
      this.nextBtn    = this.container.querySelector('#btn-next-step');
      this.textarea   = this.container.querySelector('#personal-message');
      this.charCount  = this.container.querySelector('#char-count');

      if (this.dropZone) {
        ['dragenter','dragover'].forEach(ev => {
          this.dropZone.addEventListener(ev, e => { e.preventDefault(); this.dropZone.classList.add('drag-over'); });
        });
        ['dragleave','drop'].forEach(ev => {
          this.dropZone.addEventListener(ev, () => this.dropZone.classList.remove('drag-over'));
        });
        this.dropZone.addEventListener('drop', e => { e.preventDefault(); this.handleFiles([...e.dataTransfer.files]); });
        this.dropZone.addEventListener('click', () => this.fileInput && this.fileInput.click());
      }
      if (this.fileInput) {
        this.fileInput.addEventListener('change', e => this.handleFiles([...e.target.files]));
      }
      if (this.textarea) {
        this.textarea.addEventListener('input', () => {
          if (this.charCount) this.charCount.textContent = this.textarea.value.length;
        });
      }
      this.updateUI();
    }

    async handleFiles(files) {
      const allowed = ['image/jpeg','image/png','image/heic','image/heif','image/webp'];
      const valid = files.filter(f => allowed.includes(f.type.toLowerCase()) || /\.(heic|heif)$/i.test(f.name));
      if (!valid.length) { this.showError('Format non supporté. Utilisez JPG, PNG ou HEIC.'); return; }
      if (this.photos.length + valid.length > this.maxPhotos) {
        this.showError(`Maximum ${this.maxPhotos} photos autorisées.`); return;
      }
      for (const file of valid) {
        const preview = await this.readFile(file);
        this.photos.push({ file, preview, id: crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substr(2,9) });
      }
      this.renderThumbs();
      this.updateUI();
    }

    readFile(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.readAsDataURL(file);
      });
    }

    renderThumbs() {
      if (!this.thumbGrid) return;
      this.thumbGrid.innerHTML = '';
      this.photos.forEach((photo, i) => {
        const div = document.createElement('div');
        div.className = 'photo-thumb';
        div.innerHTML = `
          <img src="${photo.preview}" alt="Photo ${i+1}" loading="lazy">
          <button class="photo-thumb-del" data-id="${photo.id}" type="button" aria-label="Supprimer">×</button>
          <span class="photo-thumb-index">${i + 1}</span>
        `;
        this.thumbGrid.appendChild(div);
      });
      this.thumbGrid.querySelectorAll('.photo-thumb-del').forEach(btn => {
        btn.addEventListener('click', e => { e.stopPropagation(); this.removePhoto(btn.dataset.id); });
      });
    }

    removePhoto(id) {
      this.photos = this.photos.filter(p => p.id !== id);
      this.renderThumbs();
      this.updateUI();
    }

    updateUI() {
      if (this.countEl) {
        const n = this.photos.length;
        this.countEl.textContent = n === 0 ? 'Aucune photo' : `${n} photo${n > 1 ? 's' : ''} sélectionnée${n > 1 ? 's' : ''}`;
      }
      if (this.nextBtn) this.nextBtn.disabled = this.photos.length < this.minPhotos;
    }

    goTo(step) {
      this.step = step;
      this.container.querySelectorAll('.uploader-panel').forEach(p => p.classList.remove('active'));
      this.container.querySelectorAll('.uploader-step-tab').forEach(t => t.classList.remove('active'));
      const panel = this.container.querySelector(`[data-panel="${step}"]`);
      const tab   = this.container.querySelector(`[data-step="${step}"]`);
      if (panel) panel.classList.add('active');
      if (tab) tab.classList.add('active');
      if (step === 4) {
        const n = this.photos.length;
        const finalCount = this.container.querySelector('#final-count');
        if (finalCount) finalCount.textContent = `${n} photo${n > 1 ? 's' : ''}`;
      }
    }

    async addToCart(productId, variantId) {
      const btn = this.container.querySelector('#btn-add-to-cart');
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours...'; }
      try {
        const message = this.textarea ? this.textarea.value : '';
        // Encode photos as data URIs in cart attributes (for small orders)
        // For production use UploadKit/Uploadery to get real URLs
        const photoData = this.photos.map((p, i) => ({ index: i + 1, name: p.file.name, size: p.file.size }));
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_Message personnalisé': message,
              '_Nombre de photos': String(this.photos.length),
              '_Photos info': JSON.stringify(photoData)
            }
          })
        });
        if (!resp.ok) throw new Error('Cart error');
        updateCartCount();
        window.location.href = '/cart';
      } catch(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Réessayer'; }
        this.showError('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
      }
    }

    showError(msg) {
      let el = this.container.querySelector('.uploader-error');
      if (!el) { el = document.createElement('div'); el.className = 'uploader-error'; this.container.prepend(el); }
      el.textContent = msg;
      el.style.cssText = 'background:#fee;color:#a00;padding:0.75rem 1rem;border-radius:4px;font-size:0.875rem;margin-bottom:1rem;';
      setTimeout(() => el.remove(), 5000);
    }
  }

  // Init uploaders
  document.querySelectorAll('[data-uploader]').forEach(el => {
    const uploader = new StoriyaUploader(el);
    // Expose goTo globally for onclick attributes in Liquid
    el._uploader = uploader;
  });

  // Global helpers used by Liquid onclick attributes
  window.uploaderGoTo = (step, containerSelector) => {
    const el = document.querySelector(containerSelector || '[data-uploader]');
    if (el && el._uploader) el._uploader.goTo(step);
  };
  window.uploaderAddToCart = (productId, variantId) => {
    const el = document.querySelector('[data-uploader]');
    if (el && el._uploader) el._uploader.addToCart(productId, variantId);
  };

  // ── PRODUCT GALLERY THUMBNAILS ──
  document.querySelectorAll('.product-gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.product-gallery-main');
      if (main) {
        main.src = thumb.dataset.full;
        document.querySelectorAll('.product-gallery-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // ── VARIANT SELECTOR ──
  document.querySelectorAll('.variant-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.variant-group');
      if (group) group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    // Collect selected options
    const opts = [...document.querySelectorAll('.variant-option.selected')].map(o => o.dataset.value);
    // Match variant (simplified — for full implementation use Shopify variant JSON)
    const variantInput = document.querySelector('[name="id"]');
    if (variantInput && opts.length) {
      // Real implementation: match against window.productVariants JSON
    }
  }

})();
